<template>
	<div class="uv-time-range" :class="{
		'uv-time-range--small': size === 'small',
		'uv-time-range--large': size === 'large'
	}"> 
		<el-time-select :size="size"
			:disabled="startProps?.disabled ?? disabled" 
			:clearable="clearable"
			v-model="start" 
			v-bind="startProps">
		</el-time-select> 
		<span class="separator">-</span>
		<el-time-select :size="size"
			:disabled="endProps?.disabled ?? disabled" 
			:clearable="clearable" 
			v-model="end" 
			v-bind="endProps" 
			:min-time="minEndTime">
		</el-time-select>
	</div>
</template>
<script setup> 
	const props = defineProps({
		size: { type: String },
		disabled: { type: Boolean, default: false },
		clearable: {
			type: Boolean,
			default: true
		},
		modelValue: {
			type: Array,
			default: () => [null, null]
		},
		startProps: {
			type: Object,
			default: () => ({})
		},
		endProps: {
			type: Object,
			default: () => ({})
		}
	})
	
	const emit = defineEmits(['update:modelValue', 'change'])

	const start = computed({
		get: () => props.modelValue?.[0] ?? null,
		set: val => emit('update:modelValue', [val, props.modelValue?.[1] ?? null])
	})
	
	const end = computed({
		get: () => props.modelValue?.[1] ?? null,
		set: val => emit('update:modelValue', [props.modelValue?.[0] ?? null, val])
	})
	
	const minEndTime = computed(() => start.value || undefined)
 
	watch(
		() => props.modelValue,
		([s, e]) => {
			if (s && e && e < s) {
				emit('update:modelValue', [s, null])
				emit('change', [s, null])
				return
			}
			
			emit('change', [s, e])
		},
		{ deep: true }
	)
</script>


<style lang="scss" scoped>
	.uv-time-range {
		display: flex;
		align-items: center;
		gap: 8px;
		border-radius: var(--el-border-radius-base);
		box-shadow: 0 0 0 1px var(--el-border-color) inset;
		padding: 0 2px;
		
		&.uv-time-range--small {
			height: 24px;
			gap: 6px;
		}
		
		&.uv-time-range--large {
			height: 40px;
			gap: 6px;
		}
		
		:deep(.el-select) {
			&.el-select--small {
				
				.el-select__wrapper {
					font-size: 12px;
					line-height: 20px;
					min-height: 22px;
					padding: 1px 4px;
				}
			}
			
			&.el-select--large {
				
				.el-select__wrapper {
					font-size: 14px;
				}
			}
			
			.el-select__wrapper {
				padding: 3px 6px;
				min-height: 30px;
				box-shadow: none;
			}
		}

		.separator {
			color: var(--el-text-color-secondary);
			user-select: none;
		}
	}
</style>